import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

const tools = [
  { name: "HTML", desc: "Markup language for creating web pages.", logo: "/images/html.png" },
  { name: "CSS", desc: "Stylesheet language for designing web pages.", logo: "/images/css-3.png" },
  { name: "Bootstrap", desc: "Responsive CSS framework for modern websites.", logo: "/images/bootstrap.png" },
  { name: "JavaScript", desc: "Programming language for dynamic web behavior.", logo: "/images/java-script.png" },
  { name: "Node.js", desc: "Runtime for building server-side applications.", logo: "/images/nodejs.png" },
  { name: "Express.js", desc: "Backend framework for Node.js to build APIs.", logo: "/images/expressjs.png" },
  { name: "React.js", desc: "Frontend library for building dynamic UIs.", logo: "/images/react.png" },
  { name: "MySQL", desc: "Relational database for storing structured data.", logo: "/images/mysql.png" },
  { name: "MongoDB", desc: "NoSQL database for flexible JSON-like documents.", logo: "/images/mongodb.png" },
  { name: "Git", desc: "Version control system to manage code changes.", logo: "/images/github.png" },
];

const FullStack = () => {
  return (
    <Container className="my-5">
      <h2 className="mb-4 text-center">Full-Stack Development Tools</h2>
      <Row className="g-4">
        {tools.map((tool, index) => (
          <Col key={index} xs={12} sm={6} md={4} lg={3}>
            <Card className="h-100 shadow-sm text-center p-3">
              {tool.logo && (
                <Card.Img
                  src={tool.logo}
                  alt={tool.name}
                  style={{ width: "80px", height: "80px", objectFit: "contain", margin: "0 auto" }}
                  className="mb-3"
                />
              )}
              <Card.Body>
                <Card.Title>{tool.name}</Card.Title>
                <Card.Text>{tool.desc}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default FullStack;
